<template>
  <div v-loading="loading">
    <el-form :model="formData" ref="formRef" :rules="rules" @submit.native.prevent label-width="100px">
        <el-form-item label="建议部门:" >
           <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="formData.group_ids" @change="handleCheckedChange">
                <el-checkbox v-for="item in suggestionList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="部门名称:" prop="group_ids">
            <JtLabelCascader
                placement="bottom-start"
                size="mini"
                class="mr20 full-w"
                popper-class="cascader-mb20 cascader-x-scroll-auto cascader-list-height-360"
                v-model="formData.group_ids"
                :options="depList"
                :props="{value:'id',label:'name',emitPath:false,expandTrigger: 'click',multiple:true, checkStrictly: true}"
                :removeDelete="false"
                :show-all-levels="false"
                clearable
                filterable
                placeholder="请选择制作部门">
            </JtLabelCascader>
        </el-form-item>
        <el-form-item label="产能:" prop="production_capacity" >
            <el-input-number 
                v-model="formData.production_capacity" 
                style="width: 200px"
                :controls="false" :step="1" 
                :min="1"
                :max="9999"
                step-strictly 
                placeholder="请输入数字"
            />
        </el-form-item>
    </el-form>
    <div class="tac">
        <el-button  @click="$emit('close')" :disabled="submitLoading">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="submitLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api/workOrder/conf'
import {JtLabelCascader } from '@/components/Ele'
export default {
    name:'AddDepartmentModal',
    props: [ 'cbs' ],
    components: {
        JtLabelCascader
    },
    data() {
        return {
            checkAll: false,
            isIndeterminate: false,
            suggestionList: [],
            depList: [],
            loading: false,
            submitLoading: false,
            formData: {
                group_ids: [],
                production_capacity: undefined,
            },
            rules: {
                group_ids: [{ required: true, message: '请选择部门', trigger: 'blur' }],
            }
        }
    },
    created() {
        this.getList()
    },
    methods: {
        handleCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.suggestionList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.suggestionList.length;
        },
        handleCheckAllChange(val) {
            this.formData.group_ids = val ? this.suggestionList.map(v=>v.id) : [];
            this.isIndeterminate = false;
        },
        async getList() {
            this.loading = true
            try {
                const [groupData, departmentData] = await Promise.all([
                    API.getTeamConfigGroup({ type: 1 }),
                    API.getProductionCapacityConfigSuggestDepartmentList()
                ]);
                this.suggestionList = departmentData.data;
                this.depList = groupData.data;
            } catch (error) {
                this.$message.error(error.info);
            }finally {
                this.loading = false
            }
        },
        async onSubmit() {
            await this.$refs['formRef'].validate();
            try {
                this.submitLoading = true
                await API.saveProductionCapacityConfigInfo(this.formData);
                this.$message.success('操作成功');
                this.cbs.onSubmit()
            } catch (error) {
                this.$message.error(error.info);
            }finally {
                this.submitLoading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>